function copyToClipBoard(content) {
  return navigator.clipboard.writeText(content);
}

export { copyToClipBoard };
//# sourceMappingURL=action.mjs.map
